import LogRocket from 'logrocket';

/*
 * @function addUsersnap
 * @description Add usersnap and append logrocket session url to snap
 */
export function addUsersnapService() {
	if (process.env.NODE_ENV === 'production') {
		window.onUsersnapLoad = function(api) {
			api.init({
				consoleRecorder: true
			});
			window.Usersnap = api;

			api.on('open', function(event) {
				LogRocket.getSessionURL(sessionsUrl => {
					console.info('logrocket session url -', sessionsUrl);
					event.api.setValue(
						'customData',
						JSON.stringify({
							logRocketSessionUrl: sessionsUrl
						})
					);
				});
			});
		};
		var script = document.createElement('script');
		script.async = 1;
		script.src = `https://api.usersnap.com/load/d78a381b-a679-443b-b19e-4862537481f8.js?onload=onUsersnapLoad`;
		document.getElementsByTagName('head')[0].appendChild(script);
	}
}

export function openUsersnap() {
	const userSnap = window.Usersnap;
	if (userSnap) userSnap.open();
}
